// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Css from "bs-css-emotion/src/Css.bs.js";
import * as SterlingTokens$LiveRoom from "../bindings/SterlingTokens.bs.js";

var animationFastest = {
  NAME: "ms",
  VAL: 300
};

var animationFast = {
  NAME: "ms",
  VAL: 300
};

var animationMedium = {
  NAME: "ms",
  VAL: 500
};

var animationSlow = {
  NAME: "ms",
  VAL: 1000
};

var mobileBreakpoint = String(768) + "px";

var tabletPortraitBreakpoint = String(980) + "px";

var desktop = "(min-width:" + String(1201) + "px)";

var tabletPortrait = "(max-width:" + String(834) + "px)";

var mobile = "(max-width:" + String(480) + "px)";

var mobileAndTablet = "(max-width:" + String(1200) + "px)";

var desktopAndTabletLandscape = "(min-width:" + String(835) + "px)";

var Breakpoint = {
  mobileWidth: 480,
  tabletPortraitWidth: 834,
  fromTabletPortraitWidth: 835,
  desktopWidth: 1200,
  fromDesktopWidth: 1201,
  desktop: desktop,
  tabletPortrait: tabletPortrait,
  mobile: mobile,
  mobileAndTablet: mobileAndTablet,
  desktopAndTabletLandscape: desktopAndTabletLandscape
};

var borderWidth = Css.px(1);

var borderColor = Css.hex(SterlingTokens$LiveRoom.Colors.primaryGrey50_nohashtag);

function defaultBorder(pos, colorOpt, param) {
  var color = colorOpt !== undefined ? colorOpt : borderColor;
  if (pos === "bottom") {
    return Css.borderBottom(borderWidth, "solid", color);
  } else if (pos === "right") {
    return Css.borderRight(borderWidth, "solid", color);
  } else if (pos === "top") {
    return Css.borderTop(borderWidth, "solid", color);
  } else {
    return Css.borderLeft(borderWidth, "solid", color);
  }
}

var animationFastestInt = 100;

var animationFastInt = 300;

var animationMediumInt = 500;

var animationSlowInt = 1000;

var notificationZIndex = 3000;

var auctionRoomZIndex = 1500;

var modalOnTopZIndex = 2500;

var book = 400;

var regular = 500;

var medium = 600;

var mobileBreakpointPixels = 768;

var tabletPortraitBreakpointPixels = 980;

var bullet = " • ";

var headerHeight = 64;

var sidebarsWidth = 376;

export {
  animationFastestInt ,
  animationFastInt ,
  animationMediumInt ,
  animationSlowInt ,
  animationFastest ,
  animationFast ,
  animationMedium ,
  animationSlow ,
  notificationZIndex ,
  auctionRoomZIndex ,
  modalOnTopZIndex ,
  book ,
  regular ,
  medium ,
  mobileBreakpointPixels ,
  tabletPortraitBreakpointPixels ,
  mobileBreakpoint ,
  tabletPortraitBreakpoint ,
  Breakpoint ,
  borderWidth ,
  borderColor ,
  defaultBorder ,
  bullet ,
  headerHeight ,
  sidebarsWidth ,
}
/* mobileBreakpoint Not a pure module */
